import { render } from "./redsysForm.vue?vue&type=template&id=86eaee2c&ts=true"
import script from "./redsysForm.vue?vue&type=script&lang=ts"
export * from "./redsysForm.vue?vue&type=script&lang=ts"

import "./redsysForm.vue?vue&type=style&index=0&id=86eaee2c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__